"use client";
import { ColumnDef } from "@tanstack/react-table";
import Table from "@/components/primitives/table";
import React from "react";
import { Injury, Sport, formatSport } from "common";
import { formatDate } from "@/utils";
import InjuryStatus from "@/components/team/injury-status";
import Link from "next/link";
import { createPlayerProfileSlug } from "@/utils/url";

export default function InjuriesTable({ injuries }: { injuries: Injury[] }) {
  const columns: ColumnDef<Injury>[] = React.useMemo(
    () => [
      {
        header: "player",
        accessorFn: (info) => {
          return `${info.player.firstName} ${info.player.lastName}`;
        },
        cell: (info) => {
          return (
            <Link
              href={createPlayerProfileSlug(formatSport(info.row.original.sport) as Sport, info.row.original.player.id)}
              className="flex flex-row gap-1 py-0"
            >
              {`${info.getValue()}`}
            </Link>
          );
        },
        width: "300px",
        enableSorting: false,
      },

      {
        header: "position",
        accessorFn: (info) => {
          return info.player.position;
        },
        minWidth: "80px",
        enableSorting: true,
      },
      {
        header: "injury",
        accessorKey: "bodyPart",
        minWidth: "200px",
        enableSorting: false,
      },
      {
        header: "updated",
        accessorKey: "lastUpdated",
        minWidth: "80px",

        enableSorting: false,
        cell: (info) => {
          return `${formatDate(info.row.original.lastUpdated)}`;
        },
      },
      {
        header: "status",
        accessorKey: "status",
        minWidth: "80px",

        enableSorting: false,
        cell: (info) => {
          return (
            <InjuryStatus status={info.row.original.status} />
          );
        },
      },
    ],
    []
  );
  return (
    <Table
      type="banded"
      columns={columns}
      data={injuries}
      cellClasses="py-2 capitalize"
    />
  );
}
